import moment from 'moment-timezone';

export function mergeTimes(pickup, pickupTime, dropoff, dropoffTime) {
  if (!dropoff || !dropoffTime || !pickupTime || !pickup) {
    // console.log(
    //   'Cannot make reservation with times:',
    //   'pickup',
    //   pickup,
    //   'pickupTime',
    //   pickupTime,
    //   'dropoff',
    //   dropoff,
    //   'dropOffTime',
    //   dropoffTime,
    // );
    return;
  }
  const dropoffDate = moment(dropoff).format('MM/DD/YYYY');
  const pickupDate = moment(pickup).format('MM/DD/YYYY');

  const newDO = moment(dropoffDate + ' ' + dropoffTime);
  const newPU = moment(pickupDate + ' ' + pickupTime);
  return {
    dropoffDate: newDO,
    pickupDate: newPU,
    dropoffDateUTC: moment(newDO).utc(),
    pickupDateUTC: moment(newPU).utc(),
  };
}

export const timezones = [
  { label: 'Denver', value: 'America/Denver' },
  { label: 'Anchorage', value: 'America/Anchorage' },
  { label: 'Boise', value: 'America/Boise' },
  { label: 'Chicago', value: 'America/Chicago' },
  { label: 'Detroit', value: 'America/Detroit' },
  { label: 'Fort_Wayne', value: 'America/Fort_Wayne' },
  { label: 'Indiana/Indianapolis', value: 'America/Indiana/Indianapolis' },
  { label: 'Indiana/Knox', value: 'America/Indiana/Knox' },
  { label: 'Indiana/Marengo', value: 'America/Indiana/Marengo' },
  { label: 'Indiana/Petersburg', value: 'America/Indiana/Petersburg' },
  { label: 'Indiana/Tell_City', value: 'America/Indiana/Tell_City' },
  { label: 'Indiana/Vevay', value: 'America/Indiana/Vevay' },
  { label: 'Indiana/Vincennes', value: 'America/Indiana/Vincennes' },
  { label: 'Indiana/Winamac', value: 'America/Indiana/Winamac' },
  { label: 'Indianapolis', value: 'America/Indianapolis' },
  { label: 'Kentucky/Louisville', value: 'America/Kentucky/Louisville' },
  { label: 'Kentucky/Monticello', value: 'America/Kentucky/Monticello' },
  { label: 'Knox_IN', value: 'America/Knox_IN' },
  { label: 'Los_Angeles', value: 'America/Los_Angeles' },
  { label: 'Louisville', value: 'America/Louisville' },
  { label: 'New_York', value: 'America/New_York' },
  { label: 'North_Dakota/Beulah', value: 'America/North_Dakota/Beulah' },
  { label: 'North_Dakota/Center', value: 'America/North_Dakota/Center' },
  { label: 'North_Dakota/New_Salem', value: 'America/North_Dakota/New_Salem' },
  { label: 'Phoenix', value: 'America/Phoenix' },
];



// WEBPACK FOOTER //
// ./src/helpers/mergeTimes.js